import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { HelmetProvider } from "react-helmet-async";

import { locationIndexOperations } from "../ducks/location-index";
import { locationDetailsOperations } from "../ducks/location-details";
import Index from "../components/index/Index";
import Error from "../components/misc/Error";
import Loading from "../components/misc/Loading";

class HomeContainer extends React.Component {
    componentDidMount() {
        this.props.fetchAllLocations();
    }

    render() {
        if (this.props.error) {
            return <Error error={this.props.error} />;
        }

        if (this.props.loading) {
            return <Loading />;
        }

        return (
            <HelmetProvider>
                <Index
                    ungroupedLocations={this.props.ungroupedLocations}
                    manyItemStates={this.props.manyItemStates}
                    fewItemStates={this.props.fewItemStates}
                    completed={this.props.completed}
                    searchByZip={this.props.searchByZip}
                    showingAll={this.props.showingAll}
                    jumpToLocation={this.props.jumpToLocation}
                    jumpToCurrentLocation={this.props.jumpToCurrentLocation}
                    jumpToCurrentLocationError={
                        this.props.jumpToCurrentLocationError
                    }
                    geographicCenter={this.props.geographicCenter}
                />
            </HelmetProvider>
        );
    }
}

const propTypes = {
    locations: PropTypes.object,
    loading: PropTypes.bool
};

HomeContainer.propTypes = propTypes;

const mapStateToProps = state => ({
    error: state.locationIndex.error,
    loading: state.locationIndex.loading,
    ungroupedLocations: state.locationIndex.ungroupedLocations,
    manyItemStates: state.locationIndex.manyItemStates,
    fewItemStates: state.locationIndex.fewItemStates,
    geographicCenter: state.locationIndex.geographicCenter,
    showingAll: state.locationIndex.showingAll,
    jumpToCurrentLocationError: state.locationDetails.jumpToCurrentLocationError
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchAllLocations: () => {
        locationIndexOperations.fetchAllLocations()(dispatch);
    },
    searchByZip: zip =>
        ownProps.$transition$.router.stateService.go("zip", { zip }),
    jumpToLocation: location =>
        ownProps.$transition$.router.stateService.go("doublePath", {
            firstPath: location.statecode,
            secondPath: location.urlKey
        }),
    jumpToCurrentLocation: () =>
        locationDetailsOperations.jumpToCurrentLocation(
            ownProps.$transition$.router.stateService.go
        )(dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeContainer);



// WEBPACK FOOTER //
// ./containers/HomeContainer.jsx